export const TID = {
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  loginError: "login-error-message",
  sidebarLogout: "sidebar-logout-button",
  sidebarWhiteboard: "sidebar-nav-whiteboard",
  sidebarMyTasks: "sidebar-nav-my-tasks",
  sidebarDailyLog: "sidebar-nav-daily-log",
  sidebarTeam: "sidebar-nav-team",
  sidebarReports: "sidebar-nav-reports",
  addTaskBtn: "add-task-button",
  taskDialogTitle: "task-dialog-title-input",
  taskDialogDesc: "task-dialog-desc-input",
  taskDialogClient: "task-dialog-client-input",
  taskDialogNas: "task-dialog-nas-input",
  taskDialogDeadline: "task-dialog-deadline-input",
  taskDialogAssignee: "task-dialog-assignee-select",
  taskDialogPriority: "task-dialog-priority-switch",
  taskDialogSubmit: "task-dialog-submit-button",
  taskCard: (id) => `task-card-${id}`,
  taskHistoryBtn: (id) => `task-history-btn-${id}`,
  taskEditBtn: (id) => `task-edit-btn-${id}`,
  taskPriorityBtn: (id) => `task-priority-btn-${id}`,
  memberAddBtn: "member-add-button",
  memberDeleteBtn: (id) => `member-delete-btn-${id}`,
  dailyLogSaveBtn: "daily-log-save-button",
  dailyLogWhatsappBtn: "daily-log-whatsapp-button",
  dailyLogOvertime: "daily-log-overtime-select",
  dailyLogOvertimeClient: "daily-log-overtime-client-input",
  dailyLogLeave: "daily-log-leave-switch",
  reportPdfBtn: "report-pdf-download-button",
  reportUserSelect: "report-user-select",
  reportMonthInput: "report-month-input",
};
